var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_1",
    x: 0,
    y: 0,
    width: 175,
    height: 175,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8",
    "data-name": "Ret\\xE2ngulo 8",
    width: 102.888,
    height: 83.667,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_53",
    "data-name": "Grupo 53",
    transform: "translate(-542 -104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 542, 104)",
    filter: "url(#Elipse_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1-2",
    "data-name": "Elipse 1",
    cx: 78.5,
    cy: 78.5,
    r: 78.5,
    transform: "translate(9 6)",
    fill: "#ea2253"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(574.874 140.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M101.952,78.886l.023-.152a7.207,7.207,0,0,0-.073-7.119,8.1,8.1,0,0,0-1.025-1.582,7.835,7.835,0,0,0-.616-.707,8.327,8.327,0,0,0,.18-11.774c-.059-.06-.119-.12-.18-.178a8.328,8.328,0,0,0,.18-11.775c-.059-.059-.119-.119-.18-.178a8.355,8.355,0,0,0-5.837-14.344H77.563A36.683,36.683,0,0,0,78.5,10.095,13.3,13.3,0,0,0,65.567,0H62.334a2.521,2.521,0,0,0-2.558,2.142,2.346,2.346,0,0,0,.06.83A29.755,29.755,0,0,1,50.524,32.7l-3.613,3.161H40.639V33.466a2.39,2.39,0,0,0-2.39-2.39h-23.9a2.392,2.392,0,0,0-2.392,2.392v2.39H0v4.781H11.952V74.1H0v4.781H11.952v2.392a2.39,2.39,0,0,0,2.39,2.389H38.249a2.39,2.39,0,0,0,2.39-2.389V78.886h6.615a47.915,47.915,0,0,0,20.809,4.781H94.424a7.234,7.234,0,0,0,3.4-.78l0,.014c.033-.021.061-.044.094-.065a9.459,9.459,0,0,0,2.538-2.093,10.324,10.324,0,0,0,1.133-1.384c.122-.16.24-.3.363-.473m-66.095,0H16.734V35.858H35.858Zm58.567,0H68.063a43.073,43.073,0,0,1-19.184-4.542A2.412,2.412,0,0,0,47.81,74.1H40.639V40.639H47.8a2.4,2.4,0,0,0,1.581-.594L53.674,36.3A34.5,34.5,0,0,0,65.082,4.782h.479a8.533,8.533,0,0,1,8.306,6.473A31.965,31.965,0,0,1,72.527,31l-.039.075H66.935v4.782H94.218a3.729,3.729,0,0,1,3.774,3.216,3.587,3.587,0,0,1-3.568,3.956H88.448V47.81h5.977a3.587,3.587,0,0,1,3.568,3.954,3.724,3.724,0,0,1-3.77,3.217H88.448v4.781h5.77a3.729,3.729,0,0,1,3.774,3.217,3.587,3.587,0,0,1-3.568,3.955H88.448v4.781h5.77a3.73,3.73,0,0,1,3.774,3.217,3.587,3.587,0,0,1-3.568,3.955",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7",
    "data-name": "Ret\\xE2ngulo 7",
    width: 4.781,
    height: 4.78,
    transform: "translate(23.905 69.324)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeBg);
export default __webpack_public_path__ + "static/media/like_bg.86830f10cd0dfedee3ec9314c21298ac.svg";
export { ForwardRef as ReactComponent };